import React from "react";

export const sideBarPatient = [
	{
		title: "Doctors",
		link: "/dashboard/patient/getdoctors",
	},
	{
		title: "View Current Appointments",
		link: "/dashboard/patient/currentappt",
	},
	{
		title: "Wallet",
		link: "/dashboard/patient/wallet",
	},
	{
		title: "View Past Appointments",
		link: "/dashboard/patient/pastappt",
	},
	{
		title: "View Pending Appointments",
		link: "/dashboard/patient/pendingappt",
	},
];
